export default __webpack_public_path__ + "static/media/7_3_logo.f26eddb2.png";